import { useMutation } from '@tanstack/react-query';
import { Address } from 'hooks/webapi/foxentry/FoxentryApiTypes';
import useError from '../../useError';
import useSmartlook from '../../useSmartlook';
import { sortCompaniesWithCzechFirst } from './showCzechCompaniesFirst';

export const useCompaniesByIdMutation = () => {
  const { showError } = useError();
  const { error } = useSmartlook();

  return useMutation({
    mutationFn: async ({
      registrationNumber,
    }: {
      registrationNumber: number;
    }) => {
      try {
        const result = await fetch('https://api.foxentry.com/company/search', {
          method: 'post',
          body: JSON.stringify({
            request: {
              query: { type: 'registrationNumber', value: registrationNumber },
              options: { dataScope: 'extended' },
            },
          }),
          headers: {
            authorization: `Bearer ${import.meta.env.VITE_FOXENTRY_API_KEY}`,
          },
        });

        const fetchedResult = await result.json();

        return sortCompaniesWithCzechFirst(fetchedResult);
      } catch (e) {
        error(
          '[useCompaniesByIdMutation][GET https://api.foxentry.com/company/search]',
          e,
        );
        if (e instanceof Error) {
          showError(e);
        }
        throw e;
      }
    },
  });
};

export type EmployerOptionData = {
  name: string;
  registrationNumber: number;
  country: 'CZ' | 'SK' | 'PL';
  address?: {
    data: {
      streetWithNumber: string;
      city: string;
      zip: string;
    };
  };
  addressOfficial?: {
    data: Address;
  };
  uuid: number;
  nace: {
    code: string;
    name: string;
    isPrimary: boolean;
  }[];
};

export type EmployerOption = {
  data: EmployerOptionData;
};
